import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import FitViewSvg from '@/components/FlowTree/assets/fit-view.svg';
import RecenterSvg from '@/components/FlowTree/assets/re-center.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'PanZoomControls',
  props: {
    isLeftSideDrawerOpen: { type: Boolean },
    isTaskLogOpen: { type: Boolean },
    isVersionHistoryOpen: { type: Boolean },
    isWideWidget: { type: Boolean },
    zoomScale: null
  },
  emits: ["recenter", "fitView"],
  setup(__props: any, { emit }: { emit: ({ (e: 'recenter'): void; (e: 'fitView'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
	isLeftSideDrawerOpen?: boolean;
	isTaskLogOpen?: boolean;
	isVersionHistoryOpen?: boolean;
	isWideWidget?: boolean;
	zoomScale: number;
}



const onRecenterClick = () => emit('recenter');
const onFitViewClick = () => {
	emit('fitView');
};
const zoomScalePercentage = computed(() => `${Math.round(props.zoomScale * 100)}%`);

return { __sfc: true,props, emit, onRecenterClick, onFitViewClick, zoomScalePercentage, FitViewSvg, RecenterSvg }
}

})